import { GiftIcon } from '@infl-ts/ui-advocate-icons';
import { Box } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

var Icon = function Icon() {
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      background: function background(t) {
        return t.palette.secondary.background;
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    "data-element": "Box",
    "data-component": "Icon",
    "data-source-file": "gift-icon.tsx",
    children: /*#__PURE__*/_jsx(GiftIcon, {
      sx: {
        transform: 'scale(3)',
        fill: function fill(t) {
          return t.palette.secondary.dark;
        }
      },
      "data-element": "GiftIcon",
      "data-component": "Icon",
      "data-source-file": "gift-icon.tsx"
    })
  });
};

export default Icon;